import React from "react";

import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import useResponsiveFlags from "../../hooks/useResponsiveFlags";

export default function DockerTableHead(props) {
  const { order, orderBy, onSort } = props;
  const { isSmallMobileScreen } = useResponsiveFlags();
  return (
    <TableHead>
      <TableRow>
        <TableCell
          style={
            !isSmallMobileScreen
              ? {
                  position: "sticky",
                  top: 0,
                  left: 0,
                  zIndex: 11,
                }
              : {}
          }
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              ID
            </span>
            <SortingIcon
              order={order}
              active={orderBy === "id"}
              onClick={() => onSort("id")}
            />
          </div>
        </TableCell>
        
        <TableCell style={{ minWidth: "126.5px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              User ID
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "username"}
              onClick={() => onSort("username")}
            />
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "126.5px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              User IP
            </span>
          </div>
        </TableCell>
        <TableCell>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Timestamp
            </span>
            <SortingIcon
              order={order}
              active={orderBy === "timestamp"}
              onClick={() => onSort("timestamp")}
            />
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "134px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Module
            </span>
          </div>
        </TableCell>
        
      </TableRow>
    </TableHead>
  );
}

function SortingIcon({ order, active, onClick }) {
  return (
    <span
      onClick={onClick}
      style={{
        cursor: "pointer",
        display: "inline-flex",
        flexDirection: "column",
        //   alignItems: "center",
        //   marginLeft: "5px",
      }}
    >
      <span
        style={{
          color: active && order === "asc" ? "#000" : "#ccc",
          fontSize: "0.5rem",
          lineHeight: "0.5rem",
        }}
      >
        ▲
      </span>
      <span
        style={{
          color: active && order === "desc" ? "#000" : "#ccc",
          fontSize: "0.5rem",
          lineHeight: "0.5rem",
        }}
      >
        ▼
      </span>
    </span>
  );
}
